module.exports = __webpack_public_path__ + "img/austria-tuberculosis-male.113bfd2a.png";